export function toAbsoluteUrl(input?: string): string {
  if (!input) return ''

  try {
    return new URL(input).toString()
  } catch (firstError) {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    try {
      return new URL(input, base).toString()
    } catch (fallbackError) {
      console.error('Failed to resolve collection endpoint URL', fallbackError ?? firstError)
      return input
    }
  }
}
